import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { of } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
import { FormChangeService } from './form-change.service';

export interface DirtyComponent {
  isDirty$: Observable<boolean>;
}

@Injectable({ providedIn: 'root' })
export class DirtyCheckGuard  {
  constructor(private formChangeService: FormChangeService) {
  }

  canDeactivate(): boolean | Observable<boolean> {
    return this.formChangeService.isDirty$.pipe(switchMap(dirty => {
      if (dirty === false) {
        return of(true);
      } else {
        if (!this.formChangeService.isDrawerOpen) {
          return of(true)
        }

        let result: boolean;
        return this.formChangeService.executeDialog(() => {
          this.formChangeService.onConfirm();
          result = true;
        }, () => {
          this.formChangeService.onCancel();
          result = false;
        }).pipe(map(() => {
          return result
        }));
      }
    }), take(1));
  }
}
